import { createContext, useContext, useEffect, useRef, useState } from 'react'

import * as PIXI from 'pixi.js'

const PIXIContext = createContext<PIXI.Application | null>(null)

export const usePIXI = () => useContext(PIXIContext)

export const Canvas = ({ children }: { children: React.ReactNode }) => {
  const canvas = useRef<HTMLCanvasElement | null>(null)
  const [app, setApp] = useState<PIXI.Application | null>(null)

  useEffect(() => {
    if (!canvas.current || !canvas.current.parentElement) return

    const newApp = new PIXI.Application({
      view: canvas.current,
      backgroundAlpha: 0,
      autoDensity: true,
      antialias: true,
      resolution: window.devicePixelRatio,
      resizeTo: canvas.current.parentElement,
    })
    setApp(newApp)

    return () => {
      newApp.destroy(true, { children: true })
    }
  }, [canvas])

  useEffect(() => {
    return () => {
      app?.stage?.removeChildren()
    }
  }, [app])

  return (
    <PIXIContext.Provider value={app}>
      <canvas ref={canvas} />
      {app && app.stage && <>{children}</>}
    </PIXIContext.Provider>
  )
}
